import { IAmendmentAddEditRequest } from '../../../../model/sge/amendment/request/amendment-add-edit-request';
import { IAmendmentResponse } from '../../../../model/sge/amendment/response/amendment-response';
import { ValidationErrors, isBlank, isEmptyId } from '../../../../utils/validation';

export type AmendmentField =
    | 'name' | 'year' | 'status' | 'type' | 'parlamentarId' | 'politicalPartyId' | 'totalAmount'
    | 'budgetUnitId' | 'budgetProgramId' | 'budgetActionId' | 'objectDescription';

// Unidade e programa só filtram a cascata; a API recebe apenas a ação orçamentária
export type AmendmentBudgetSelection = { budgetUnitId?: number; budgetProgramId?: number };

export function toAmendmentForm(data: IAmendmentResponse): IAmendmentAddEditRequest {
    return {
        name: data.name,
        year: data.year,
        parlamentarId: data.parlamentarId,
        politicalPartyId: data.politicalPartyId,
        type: data.type,
        totalAmount: data.totalAmount,
        budgetActionId: data.budgetActionId,
        legalBasis: data.legalBasis,
        objectDescription: data.objectDescription,
        publicPurpose: data.publicPurpose,
        targetAudience: data.targetAudience,
        executionLocation: data.executionLocation,
        institutionalJustification: data.institutionalJustification,
        status: data.status,
    };
}

export function validateAmendment(form: IAmendmentAddEditRequest, budget: AmendmentBudgetSelection): ValidationErrors<AmendmentField> {
    const errors: ValidationErrors<AmendmentField> = {};
    if (isBlank(form.name)) errors.name = 'Nome é obrigatório';
    if (isEmptyId(form.year)) errors.year = 'Exercício é obrigatório';
    if (isEmptyId(form.status)) errors.status = 'Status é obrigatório';
    if (isEmptyId(form.type)) errors.type = 'Tipo é obrigatório';
    if (isEmptyId(form.parlamentarId)) errors.parlamentarId = 'Parlamentar é obrigatório';
    if (isEmptyId(form.politicalPartyId)) errors.politicalPartyId = 'Partido político é obrigatório';
    if (!form.totalAmount || form.totalAmount <= 0) errors.totalAmount = 'Valor total é obrigatório';
    if (isEmptyId(budget.budgetUnitId)) errors.budgetUnitId = 'Unidade orçamentária é obrigatória';
    if (isEmptyId(budget.budgetProgramId)) errors.budgetProgramId = 'Programa orçamentário é obrigatório';
    if (isEmptyId(form.budgetActionId)) errors.budgetActionId = 'Ação orçamentária é obrigatória';
    if (isBlank(form.objectDescription)) errors.objectDescription = 'Descrição do objeto é obrigatória';
    return errors;
}

// Para onde o Cancelar volta: a tela de origem (ex.: detalhe da emenda) ou a listagem
export function resolveReturnPath(state: unknown, fallback = '/emendas'): string {
    const from = (state as { from?: unknown } | null)?.from;
    return typeof from === 'string' && from.startsWith('/') ? from : fallback;
}
